/* eslint-disable indent */
import React from 'react';
import {
  Box,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  Paper,
  Typography,
} from '@material-ui/core';
import { Formik, FormikErrors } from 'formik';
import { PartnerFormFields } from 'modules/partners/interfaces';
import i18n from 'i18n';
import clsx from 'clsx';
import GenericForm from 'skyone-lib/lib/GenericForm';
import { Alert } from '@material-ui/lab';
import {
  addThirtyDaysToMidnight,
  dateFormatWithAtDayMonth,
} from 'utils/helpers';
import styles from './styles';

const useStyles = makeStyles(styles);

interface DisableRecaptchaProps {
  isEdit?: boolean;
  values: PartnerFormFields;
  errors: FormikErrors<PartnerFormFields>;
  isRecaptchaEnabled: boolean | undefined;
  currentReason?: string;
  setFieldValue: (field: string, value: any) => void;
}

const DisableRecaptcha = ({
  isEdit,
  values,
  errors,
  isRecaptchaEnabled,
  currentReason,
  setFieldValue,
}: DisableRecaptchaProps) => {
  const classes = useStyles();

  return (
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    <Formik initialValues={values} onSubmit={() => {}} enableReinitialize>
      {({ values }) => (
        <Paper elevation={2} className={classes.root}>
          <DialogTitle className={classes.header}>
            {i18n.t('INACTIVATE_RECAPTCHA_KEY')}
          </DialogTitle>

          <DialogContent
            dividers
            className={clsx(classes.content, {
              [classes.contentInCreation]: !isEdit,
            })}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid
                  container
                  alignItems="center"
                  className={classes.fieldset}
                >
                  <Grid item xs={12} className={classes.reasonField}>
                    {!values?.recaptcha?.enabled &&
                      (isRecaptchaEnabled ||
                        isRecaptchaEnabled === undefined) && (
                        <GenericForm
                          fields={values}
                          screenFields={[
                            {
                              gridXs: 12,
                              stateKey: 'recaptcha.reason',
                              label: i18n.t('INACTIVATING_REASON_KEY'),
                              isMultiline: true,
                              validateOnChange: true,
                            },
                          ]}
                          setFieldValue={(key, value) =>
                            setFieldValue('recaptcha.reason', value)
                          }
                          errors={errors}
                        />
                      )}
                  </Grid>
                </Grid>

                {isRecaptchaEnabled === false && !values.recaptcha.enabled && (
                  <>
                    {values.recaptcha.changed_by?.email && (
                      <Grid container className={classes.madeByGrid}>
                        <Typography
                          className={classes.madeByText}
                          component="div"
                        >
                          <Box fontWeight="bold">
                            {i18n.t('LAST_RECAPTCHA_INACTIVE_KEY')}
                          </Box>
                          {i18n.t('BY_AT_KEY', {
                            name: `${values.recaptcha.changed_by.first_name} ${values.recaptcha.changed_by.last_name} (${values.recaptcha.changed_by.email})`,
                            date: dateFormatWithAtDayMonth(
                              values.recaptcha.changed_at
                            ),
                          })}
                        </Typography>
                      </Grid>
                    )}
                    {values.recaptcha.changed_at && (
                      <Grid container className={classes.madeByGrid}>
                        <Typography
                          className={classes.madeByText}
                          component="div"
                        >
                          <Box fontWeight="bold">
                            {i18n.t('REACTIVATION_KEY')}
                          </Box>
                          {i18n.t('RELEASE_RECAPTCHA_KEY', {
                            date: addThirtyDaysToMidnight(
                              values.recaptcha.changed_at
                            ),
                          })}
                        </Typography>
                      </Grid>
                    )}

                    {currentReason && (
                      <Grid container className={classes.madeByGrid}>
                        <Typography
                          className={classes.madeByText}
                          component="div"
                        >
                          <Box fontWeight="bold">
                            {i18n.t('INACTIVATING_REASON_DETAIL_KEY')}
                          </Box>
                          {currentReason}
                        </Typography>
                      </Grid>
                    )}
                  </>
                )}

                <Grid container>
                  <Alert
                    className={classes.alert}
                    severity="warning"
                    color="info"
                  >
                    <Grid item>
                      <Typography className={classes.alertText}>
                        {i18n.t('INACTIVATE_RECAPTCHA_DESCRIPTION_KEY')}
                      </Typography>
                    </Grid>
                  </Alert>
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
        </Paper>
      )}
    </Formik>
  );
};

export default DisableRecaptcha;
